import { useContext } from "react";
import type { RunDialogPageProps } from "..";
import { RunWithContext } from "../../api-playground/run-with";
import AuthToken from "../../auth-token";
import { useRunDialogContext } from "../context";
import { MDXPageWithToc } from "../mdx-page-with-toc";
import OpenAICurl from "../openai-curl.mdx";
import OpenAIJavaScript from "../openai-javascript.mdx";
import OpenAIPython from "../openai-python.mdx";
import { GettingStartedContext } from "../snippets";

export function OpenAIPage({ token, version }: RunDialogPageProps) {
  const { language } = useRunDialogContext();

  const Content = (() => {
    switch (language) {
      case RunWithContext.NodeJS:
        return OpenAIJavaScript;
      case RunWithContext.Python:
        return OpenAIPython;
      case RunWithContext.HTTP:
        return OpenAICurl;
      default:
        throw new Error(`Unexpected language: ${language}`);
    }
  })();

  const gsp = useContext(GettingStartedContext);

  return (
    <MDXPageWithToc language={language} id="openai">
      <Content
        components={{
          AuthToken: AuthToken,
        }}
        // @ts-ignore
        token={token}
        version={version}
        {...gsp}
      />
    </MDXPageWithToc>
  );
}
